import { EventType } from '@/shared/enums';
import getQueryMixin from './get-query-mixin';

const LAZY_LOAD_AMOUNT = 50;
const LAZY_LOAD_MARGIN = 600;

export default {
  mixins: [
    getQueryMixin,
  ],
  data() {
    return {
      products: undefined,
      maxResults: LAZY_LOAD_AMOUNT,
      subscriber: this.$services.resolve('subscriber'),
    };
  },
  beforeDestroy() {
    this.unmountLazyLoadListener();
  },
  computed: {
    firstResult() {
      return this.products.collection.length;
    },
  },
  methods: {
    mountLazyLoadListener() {
      this.$EventBus.on(EventType.SCROLL, this.handleScroll);
    },
    unmountLazyLoadListener() {
      this.$EventBus.off(EventType.SCROLL, this.handleScroll);
    },
    lazyLoadItems() {
      return this.products.fetchAll({ kids: this.subscriber.isKidsTheme }, { query: this.getQuery() });
    },
    handleScroll() {
      const offset = window.scrollY + window.innerHeight + LAZY_LOAD_MARGIN;
      const height = document.documentElement.offsetHeight;

      if ((offset >= height) && (this.firstResult < this.products.meta.totalCount)) {
        this.lazyLoadItems();
      }
    },
  },
};
